import Modal from "react-bootstrap/Modal";
import closeIcon from 'assets/images/close.svg';

const LocationAlert = ({
  show,
  setShow
}) => {
  return (
    <Modal
      show={show}
      className="modal-common missing-p-pop location-alert"
      onHide={() => setShow(false)}
    >
      <Modal.Body
      >
        <img
          src={closeIcon}
          alt="close"
          className="close-icon"
          onClick={() => setShow(false)}
        />
        <div className="text-center">
          <h2 className="red-alert-text text-white">Enable Location!</h2>
          <p> 
            To continue, turn on device location, which uses Google's location service
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default LocationAlert;
